import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { parseJwt } from '../utils/jwt';
import { loginSuccess, setImpersonationAdminEmail } from '../store/auth/actions';

const useAuthTokenFromUrl = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) return;

    const payload = parseJwt(token);
    if (!payload || typeof payload !== 'object') return;

    const { exp, impersonatedBy } = payload;

    dispatch(
      loginSuccess({
        token,
        tokenExpiration: exp ? new Date(exp * 1000).toISOString() : undefined,
      })
    );

    if (typeof impersonatedBy === 'string') {
      dispatch(setImpersonationAdminEmail(impersonatedBy));
    }

    params.delete('token');
    const query = params.toString();
    window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
  }, [dispatch]);
};

export default useAuthTokenFromUrl;
